/**
 * Simplified Color Palette
 * Change the 6 core colors to retheme the entire app
 */

// ===== CORE THEME COLORS (Change these to retheme) =====
// "Dusty Blue" pastel palette — desaturated, calm Material tones.
export const themeColors = {
  primary: '#6C8EBF',   // desaturated dusty blue
  secondary: '#7FB3A8', // muted teal
  success: '#6BA368',   // soft leaf green
  warning: '#E0A458',   // muted amber
  error: '#D2726A',     // dusty terracotta
  info: '#86A9C4',      // soft sky (clearly distinct from primary)
};

// Grey scale (rarely needs changing)
export const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
};

// Full palette for MUI theme
export const colors = {
  primary: {
    main: themeColors.primary,
    light: '#E7EDF6',
    dark: '#47638F',
    contrastText: '#ffffff',
  },
  secondary: {
    main: themeColors.secondary,
    light: '#E6F1EE',
    dark: '#55897E',
    contrastText: '#ffffff',
  },
  success: {
    main: themeColors.success,
    light: '#E7F1E6',
    dark: '#497A47',
    contrastText: '#ffffff',
  },
  warning: {
    main: themeColors.warning,
    light: '#FBEFDD',
    dark: '#B27E38',
    contrastText: '#3A2E17',
  },
  error: {
    main: themeColors.error,
    light: '#F7E4E2',
    dark: '#A94E47',
    contrastText: '#ffffff',
  },
  info: {
    main: themeColors.info,
    light: '#EAF1F6',
    dark: '#5E86A3',
    contrastText: '#ffffff',
  },
  grey,
  background: {
    default: '#f6f7f5',
    paper: '#ffffff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.82)',
    secondary: 'rgba(0, 0, 0, 0.58)',
    disabled: 'rgba(0, 0, 0, 0.36)',
  },
  divider: '#e6e8e4',
};

// Chart colors using theme colors
// Ordered so adjacent series differ in hue (important for pastel tones).
export const chartColors = [
  themeColors.primary,
  themeColors.secondary,
  themeColors.warning,
  themeColors.info,
  themeColors.error,
  themeColors.success,
];

// Status color mapping
export const statusColors = {
  completed: 'success',
  active: 'success',
  pending: 'warning',
  in_progress: 'info',
  failed: 'error',
  cancelled: 'error',
};

// Health status colors
export const healthColors = {
  high: themeColors.success,
  medium: themeColors.warning,
  low: themeColors.error,
  default: grey[500],
};
